// extracted by mini-css-extract-plugin
export default {"page":"page_sxwts","isWebView":"isWebView_PL_1j","breadcrumbs":"breadcrumbs_wHROP"};